import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import PropTypes from "prop-types";
import {
    Container,
    Row,
    Col,
    Card,
    Button,
    Form
} from 'react-bootstrap';
import { 
    useLazyGetDashboardQuery,
    useGetAwsSesQuotasQuery
} from '../../app/api';

const HomeDash = () => {
    const defaultDaysBack = 30;
    const [startDate, setStartDate] = useState(moment().subtract(defaultDaysBack, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [dashdata, setDashdata] = useState({});
    const [getDashdata] = useLazyGetDashboardQuery({"start": startDate, "end": endDate});
    const {data: awsSesQuotas} = useGetAwsSesQuotasQuery();

    const handleGetData = async () => {
        setIsLoadingData(true);
        try {
            const dd = await getDashdata({
                "start": startDate,
                "end": endDate
            });
            setDashdata(dd.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            // Ensure loading stops even if there's an error
            setIsLoadingData(false);
        }
    };

    // debug
    useEffect(()=>{
        if(awsSesQuotas){
            console.log(awsSesQuotas);
        }
    }, [awsSesQuotas])

    //  run on page load
    useEffect(()=>{
        handleGetData();
    }, [])

    const COLORS = ['#c8edfd', '#00C49F', '#FFBB28', '#FF8042', '#8884d8'];
    const blueShades = [
        '#97ddfb',  // Lightest blue (adjusted to be slightly darker)
        '#7ed5fa',
        '#65cdf9',
        '#4FC3F7',
        '#29B6F6',
        '#03A9F4'   // Darkest blue
    ];

    const MetricCard = ({ value, label, backgroundColor }) => (
        <Card className="m-3" style={{ backgroundColor, color: 'white', width: '150px', display: 'inline-block' }}>
            <Card.Body>
                <h2>{value}</h2>
                <p style={{ fontSize: '0.8rem', marginBottom: 0 }}>{label}</p>
            </Card.Body>
        </Card>
    );

    MetricCard.propTypes = {
        label: PropTypes.string,
        value: PropTypes.string,
        backgroundColor: PropTypes.string,
    };

    return (
        <>
        <Container fluid className="p-3 my-3" style={{ backgroundColor: '#f0f0f0' }}>
            <h4>AWS SES Email Send Quotas</h4>
            {awsSesQuotas && 
                    <>
                        <MetricCard value={String(awsSesQuotas.emails_sent_24h)} label="Emails Sent 24hr" backgroundColor={blueShades[4]} />
                        <MetricCard value={String(awsSesQuotas.remaining_24h)} label="Rem. 24hr Quota" backgroundColor={blueShades[4]}/>
                        <MetricCard value={String(awsSesQuotas.quota_used_percentage.toFixed(2))} label="% Quota Used" backgroundColor={blueShades[4]} />
                        <p className='quotatxt'>
                            24hr Max Send Amount: <strong>{awsSesQuotas.max_24h}</strong>.
                            Send Rate: <strong>{awsSesQuotas.max_send_rate} per second</strong>
                        </p>
                    </>
            }
        </Container>
        <Container fluid className="p-3" style={{ backgroundColor: '#f0f0f0' }}>
            {/* Date Range Selector */}
            <Row className="mb-4 align-items-center">
                <Col xs="auto">
                    <Form.Label className="mb-0 me-2">Start Date:</Form.Label>
                </Col>
                <Col xs="auto">
                    <Form.Control
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        style={{ height: '38px' }}
                    />
                </Col>
                <Col xs="auto">
                    <Form.Label className="mb-0 me-2">End Date:</Form.Label>
                </Col>
                <Col xs="auto">
                    <Form.Control
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        style={{ height: '38px' }}
                    />
                </Col>
                <Col xs="auto">
                    <Button
                        variant="success"
                        onClick={handleGetData}
                        style={{ height: '38px' }}
                        disabled={isLoadingData}
                    >
                        {isLoadingData ? 'Loading...' : 'Get Data'}
                    </Button>
                </Col>
            </Row>

            {isLoadingData ? (
                <div className="text-center mt-4">
                    <img src="../images/loader.gif" width={50}/>
                    <p>Loading dashboard data...</p>
                </div>
            ) : (
                dashdata ? (
                    <div>
                        <MetricCard value={String(dashdata.sends)} label="Sends" backgroundColor={blueShades[4]} />
                        <MetricCard value={String(dashdata.deliveries)} label="Deliveries" backgroundColor={blueShades[4]} />
                        <MetricCard value={String(dashdata.opens)} label="Opens" backgroundColor={blueShades[4]} />
                        <MetricCard value={String(dashdata.clicks)} label="Clicks" backgroundColor={blueShades[4]} />
                        <MetricCard value={String(dashdata.bounces)} label="Bounces" backgroundColor={blueShades[4]} />
                    </div>
                ) : (
                    <div className="text-center mt-4">
                        <p>No data available</p>
                    </div>
                )
            )}
        </Container>
        </>
    );
};

export default HomeDash;